import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, AlertCircle } from 'lucide-react';
interface DayCardProps {
  day: number;
  title: string;
  pain: string;
  benefit: string;
  index: number;
}
export function DayCard({
  day,
  title,
  pain,
  benefit,
  index
}: DayCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay: index * 0.1
  }} className="bg-white rounded-2xl p-6 shadow-sm border border-[#52B788]/20 hover:shadow-md hover:border-[#52B788]/50 transition-all duration-300 relative overflow-hidden group" data-id="element-1">
      <div className="absolute top-0 right-0 w-24 h-24 bg-[#E8F5E9] rounded-bl-full -mr-10 -mt-10 transition-transform group-hover:scale-110" data-id="element-2" />

      <div className="relative z-10" data-id="element-3">
        <div className="flex items-center gap-3 mb-4" data-id="element-4">
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-[#2D6A4F] text-white font-bold text-lg shadow-sm" data-id="element-5">
            {day}
          </div>
          <h3 className="text-xl font-bold text-[#1B4332] leading-tight" data-id="element-6">
            {title}
          </h3>
        </div>

        <div className="space-y-3" data-id="element-7">
          <div className="flex items-start gap-2 text-sm text-gray-600 bg-red-50 p-2 rounded-lg" data-id="element-8">
            <AlertCircle className="w-4 h-4 text-red-500 mt-0.5 flex-shrink-0" data-id="element-9" />
            <p data-id="element-10">
              <span className="font-semibold text-red-700" data-id="element-11">Dolor:</span> {pain}
            </p>
          </div>

          <div className="flex items-start gap-2 text-sm text-gray-800 bg-[#E8F5E9] p-2 rounded-lg" data-id="element-12">
            <CheckCircle2 className="w-4 h-4 text-[#2D6A4F] mt-0.5 flex-shrink-0" data-id="element-13" />
            <p data-id="element-14">
              <span className="font-semibold text-[#2D6A4F]" data-id="element-15">Beneficio:</span>{' '}
              {benefit}
            </p>
          </div>
        </div>
      </div>
    </motion.div>;
}